import React, { useEffect, useState } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment, Done } from '@material-ui/icons';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import SweetAlert from 'react-bootstrap-sweetalert';
import stylesSweealert from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';

import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles({
  ...stylesSweealert,
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código', accessor: 'CardCode' },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: 'RUC/DNI', accessor: 'LicTradNum', width: 200 },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProviderModal(props) {
  const classes = useStyles();

  const {
    open,
    setOpen,
    queryType,
    purchase,
    setPurchase,
    id,
    existPurchaseDetails,
    saveHeader,
    setUnitValue,
    soloMercaderia,
  } = props;

  const [alert, setAlert] = useState(null);

  const [providers, setProviders] = useState([]);

  async function listProviders() {
    let filter = { CardType: 'S' };
    if (queryType === 'P') {
      if (soloMercaderia) {
        filter.QryGroup1 = 'Y';
      } else {
        filter.QryGroup1 = 'N';
        filter.with_self = 'Y';
      }
    }
    if (queryType === 'M') {
      filter.QryGroup1 = 'Y';
    }
    let response = await wsFindBy('base/business-partner', filter);
    if (response.success) {
      setProviders(response.data);
    }
  }

  function confirmDeleteDetails(provider) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Las líneas del detalles serán eliminados"
        onConfirm={() => {
          saveHeader(provider);
          setAlert(null);
          setOpen(false);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        ¡Si cambia de proveedor todos los detalles serán eliminados!
      </SweetAlert>
    );
  }

  useEffect(() => {
    if (open) {
      listProviders();
    }
  }, [open, soloMercaderia]);

  useEffect(() => {
    if (purchase.base_business_partner_id === undefined) {
      return;
    }
    let provider = providers.find((provider) => provider.id == purchase.base_business_partner_id);
    if (provider != null && ['P20348735692'].includes(provider.CardCode)) {
      /* setUnitLocked(true); */
      setUnitValue('Y');
    } else {
      /* setUnitLocked(false); */
    }
  }, [purchase.base_business_partner_id]);

  return (
    <>
      {alert}
      <ModalFull title="Proveedores" open={open} setOpen={setOpen}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Elija un proveedor</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              defaultWidth={1100}
              exportExcel={false}
              columns={columns}
              data={providers.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      <Button
                        justIcon
                        size="sm"
                        round
                        onClick={() => {
                          if (id != 0) {
                            if (existPurchaseDetails) {
                              confirmDeleteDetails({ base_business_partner_id: item.id });
                            } else {
                              saveHeader({ base_business_partner_id: item.id });
                              setOpen(false);
                            }
                          } else {
                            setPurchase({
                              ...purchase,
                              base_business_partner_id: item.id,
                              CardName: item.CardName,
                              Address: item.Address,
                            });
                            setOpen(false);
                          }
                        }}
                        color="success"
                      >
                        <Done />
                      </Button>
                    </div>
                  ),
                  CardCode: item.CardCode,
                  CardName: item.CardName,
                  LicTradNum: item.LicTradNum,
                  state: item.frozenFor === 'N' ? 'Activo' : 'Inactivo',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </ModalFull>
    </>
  );
});
